/**
 * Gedeelde design-tokens + constanten voor het widget-systeem.
 * Eén bron van waarheid zodat WidgetShell, WidgetGrid en alle widgets identiek
 * ogen. Zie docs/widget-design-principles.md voor het volledige principe.
 */

export const T = {
  primary: '#526075', tertiary: '#635983',
  bg: '#f8f9fa', surface: '#ffffff', surfaceLow: '#f1f4f5', surfaceHigh: '#e5e9eb',
  text: '#2d3335', secondary: '#556071', outline: '#767c7e', outlineVariant: '#adb3b5',
  emerald: '#10b981', emeraldBg: '#ecfdf5', amber: '#f59e0b',
  primaryContainer: '#d5e3fd',
  shadow: '0 10px 30px rgba(45,51,53,0.06)',
  shadowHover: '0 14px 38px rgba(45,51,53,0.12)',
  font: '"Manrope", system-ui, sans-serif',
  fontBody: '"Inter", system-ui, sans-serif',
};

export const Icon = ({ name, fill, size = 20, sx = {} }) => (
  <span
    className="material-symbols-outlined"
    style={{
      fontSize: size,
      fontVariationSettings: `'FILL' ${fill ? 1 : 0}, 'wght' 500, 'GRAD' 0, 'opsz' ${size}`,
      lineHeight: 1,
      ...sx,
    }}
  >
    {name}
  </span>
);

// ── Grid ──────────────────────────────────────────────────────────────────
// Max 3 kolommen breed. Responsive collapse gebeurt in WidgetGrid.
export const MAX_COLS = 3;
export const GRID_GAP = 18; // px — gebruikt voor zowel layout als resize-rekenwerk

// ── Hoogte ────────────────────────────────────────────────────────────────
// Discrete stappen. 'auto' = volgt de inhoud; de overige cappen de body-hoogte
// met interne scroll. De volgorde bepaalt de stepper- en sleep-richting.
export const HEIGHT_ORDER = ['auto', 'compact', 'normal', 'tall'];
export const HEIGHT_PX = { compact: 200, normal: 340, tall: 500 };
export const HEIGHT_LABEL = { auto: 'Auto', compact: 'Compact', normal: 'Normaal', tall: 'Hoog' };

// Body-hoogte (px) voor een hoogte-modus, of null voor 'auto'.
export const bodyHeightPx = (mode) => HEIGHT_PX[mode] ?? null;
